module.exports = __webpack_public_path__ + "img/gif-page-back.2941b863.gif";